var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner"},[_c('p',{staticClass:"partner__title"},[_vm._v("Powered by the following partners:")]),_c('PartnerImg',{attrs:{"divclass":"partner__img"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }